import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import TiposCustasService from '../../app/service/TiposCustasService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

class TiposCustas extends React.Component {

  constructor(props) {
    super(props)

    this.tiposCustasService = new TiposCustasService();
    this.accept = this.accept.bind(this);
    this.acoes = this.acoes.bind(this);
    this.renderFooterAlterarTipos = this.renderFooterAlterarTipos.bind(this);
    this.renderFooterCadastroTipos = this.renderFooterCadastroTipos.bind(this);

    this.state = {
      //Cadastro
      codigo: '',
      nome: '',
      empresa: null,
      tiposCustas: [],
      modalCadastro: false,
      modalAlterar: false,
      visivble: false,
      //Progresso
      classeDiv: 'hide'
    }
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  accept() {
    this.excluirTipoCusta();
  }

  cadastrarTiposCustas = async () => {
    this.setState({ classeDiv: 'show'});
    if(this.state.nome === '') {
      this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:'Informe o nome do Tipo de Custa', life: 4000});
      return false;
    }
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tiposCustasService.cadastrarTipoCusta({
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Tipos de Custas', detail:'Tipo de Custa cadastrado com sucesso', life: 4000});
      this.listarTiposCustas();
    }).catch(error => {
      this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalCadastro');
    this.setState({classeDiv: 'hide'});
  }

  listarTiposCustas = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado
    await this.tiposCustasService.listarTiposCusta(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposCustas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:`${this.state.detail}`, life: 4000});
      });

    this.setState({classeDiv: 'hide'});
  }

  async editar(tipo) {
    this.setState({classeDiv: 'show'});
    if(tipo != null) {
      await this.tiposCustasService.consultarTipoCusta(tipo.codigo)
        .then(response => {
          this.setState({codigo: response.data.codigo});
          this.setState({nome: response.data.nome});
          this.abrirModaAlterar('modalAlterar');
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:`${this.state.detail}`, life: 4000});
        });
    }
    this.setState({classeDiv: 'hide'});
  }

  alterarTipoCustas = async () => {
    this.setState({classeDiv: 'show'});
    if(this.state.nome === '') {
      this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:'Informe o nome do Tipo de Custa', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }
    const usuarioLogado = this.context.usuarioAutenticado
    this.tiposCustasService.alterarTipoCusta({
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.listarTiposCustas();
      this.toast.show({severity:'success', summary: 'Tipos de Custas', detail:'Tipo de Custa alterado com sucesso', life: 4000});
      this.fecharModalCadastro('modalAlterar')
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:`${this.state.detail}`, life: 4000});
    });

    this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroTipos(name) {
    return (
        <div>
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTiposCustas}/> 
        </div>
    );
  }

  renderFooterAlterarTipos(name) {
    return (
        <div>
             <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModalCadastro(name)}/>
              
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTipoCustas}/> 
        </div>
    );
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.editar(rowData)}
                tooltip="Editar Tipo de Custas" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Custas" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(tipo) {
    this.setState({codigo: tipo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Tipo de Custa?',
        header: 'Exclusão de Tipo de Custa',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  async excluirTipoCusta() {
    this.setState({classeDiv: 'show'});
    this.tiposCustasService.excluirTipoCusta(this.state.codigo)
      .then(response => {
        this.listarTiposCustas();
        this.toast.show({severity:'success', summary: 'Tipos de Custas', detail:'Tipo de Custa excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Custas', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  componentDidMount() {
    this.listarTiposCustas();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          {/**Cadastro de Tipo de Custas */}
          <Dialog header="Cadastro de Tipo de Custas"
                    visible={this.state.modalCadastro} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTipos('modalCadastro')} 
                    onHide={() => this.fecharModalCadastro('modalCadastro')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeGrupo">Nome</label>
                        <InputText id="nomeGrupo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Tipo de Pagamento */}
          <Dialog header="Alterar Tipo de Custas"
                    visible={this.state.modalAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTipos('modalAlterar')} 
                    onHide={() => this.fecharModalCadastro('modalAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTipo">Nome</label>
                        <InputText id="nomeTipo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <ConfirmDialog visible={this.state.visible} 
                         onHide={() => this.setState({ visible: false })} 
                         message="Are you sure you want to proceed?"
                         header="Confirmation"
                         icon="pi pi-exclamation-triangle" 
                         accept={() => this.excluirTipoCusta} 
                         reject={() => this.setState({visible: false})}/>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-dollar-sign"></i>
                        <span> Tipos de Custas</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalCadastro')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    <Progresso classeSecundaria={this.state.classeDiv}/>
                    </div>
                    <DataTable value={this.state.tiposCustas}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column field="descricao" header="Descrição"></Column>
                      <Column key="codigo"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TiposCustas.contextType = AuthContext;
export default withRouter (TiposCustas)